import { useLocation, useNavigate } from "react-router";
import image from "../img/background-image-delete-document.png";
import { useContext, useEffect, useState } from "react";
import { DocumentList } from "../components/DocumentList";
import useAxiosRequests from "../hooks/useAxiosRequest";
import ExternalRoutes from "../config/ExternalRoutes";
import { MessageContext } from "../context/MessageContext";
import { CircularProgress } from "@mui/material";

export const DeleteDocument = () => {
    const location = useLocation();
    const documents = location.state?.documents || {};
    const navigate = useNavigate();
    const { sendRequest } = useAxiosRequests();
    const { showSuccess, showError } = useContext(MessageContext);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (!documents) navigate("/");
    }, [])


    const handleDelete = async () => {
    setLoading(true);
        try {
            const response = await sendRequest({ method: "DELETE", url: ExternalRoutes.document.delete + documents?.id });
            if (response.status === 'error') {
                showError(response.message || "Une erreur est survenue lors de la suppression.");
                return; 
            }
            showSuccess(response.message || "Suppression effectuée avec succès.");
            navigate("/");
        } catch (error) {
            showError("Une erreur est survenue lors de la suppression.");
        }finally{
    setLoading(false);

        }
    };

    return <>
        <section className="kl-delete-facture">
            <div className="kl-image-background">
                <img src={image} alt="delete document image" aria-hidden="true" />
            </div>
            <div className="kl-display-delete-document">
                <h2>Êtes vous sûr de vouloir supprimer ce document?</h2>
                {documents ? (
                    <DocumentList document={documents} type={documents?.conDocumentStatus?.docStName} />
                ) : (
                    <></>
                )}
            </div>
        </section>
        <section className="kl-delete-doc-content">
            <div className="kl-button-delete-document">
                <button className="btn kl-button-supprimer" onClick={handleDelete || loading}>
                    {
                        loading ?  
                        <>
                            <CircularProgress size={15} color="inherit"  />
                            <span className="mx-2">Suppression ... </span>
                        </>
                        :
                    "Supprimer"
                    }
                </button>
                <button onClick={() => window.history.back()} className="btn kl-button-back">
                    Revenir
                </button>
            </div>
        </section>
    </>
};
